import React, { useState,useEffect,useRef } from 'react'
import {setAuditEnrichProduct} from '../../actions/auditEnrich';
import { useDispatch, useSelector } from 'react-redux';
import {useHistory} from 'react-router-dom';
import {logOut , fetchAuditEnrichProduct } from '../../utills';
import {setLoggedUser} from '../../actions/index';


import './audit-enrich-home.scss'
import Button from 'jd-library/Button';


const AuditEnrichHome = () => {

    const [failResponse, setFailResponse] = useState('')
    const session = useSelector((state)=> state.session);
    let dispatch = useDispatch();
    let history = useHistory();

   

    const logOutUser = ()=> {

		logOut({
			token : session.token,
			cb:(data)=> {
				if (data.data.isSuccess){
					dispatch(setLoggedUser(null))
					history.push("/audit-enrich-login");

				}
			}
		})
	}

const checkFailRes = (msg) =>{
    setFailResponse(msg);
}



  return (
    <div className='enrich_container'>
        <div className='enrichHome'>
            <div className='enrich-heading'>Audit Enriched Products</div>
            <Button  onClick={()=>fetchAuditEnrichProduct(checkFailRes)}>Start for Branded Products</Button>
            <Button  disabled>Start for Custom Products</Button><br/><br/>

                <Button className='logout_button' onClick={logOutUser}>Log Out</Button>
            <br/><br/>
            {failResponse && <div className='faliedMessage'><p>{failResponse}</p></div>}
        </div>
    </div>
    

  )
}

export default AuditEnrichHome